export default $ => {

    // Avvia clipboard.js
    new Clipboard('[data-clipboard]');

};



// WEBPACK FOOTER //
// ./assets/js/component/clipboard.js